import { render, staticRenderFns } from "./WidgetNetworkCa.vue?vue&type=template&id=65060c17"
import script from "./WidgetNetworkCa.vue?vue&type=script&lang=js"
export * from "./WidgetNetworkCa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports